import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { DownloadExcel } from 'react-excel-export';
import CsvDownloadButton from 'react-json-to-csv';
import { Link } from 'react-router-dom';
import Tooltip from 'react-simple-tooltip';

import axios from 'axios';
import { useAccount } from 'wagmi';

import { useGlobalContext } from '../../AppContext';
import {
  add_favorite_token,
  add_favorite_whale,
  remove_favorite_token,
  remove_favorite_whale,
} from '../../utils/apiOperations';
import {
  calculateColumnWidth,
  notify,
  parseAmount,
  parseMoney,
  parseNumber,
  parsePercentage,
} from '../../utils/utils';
import { AddReminderToken } from '../../components/AddReminderToken';
import { BigMenu } from '../../components/BigMenu';
import { Button } from '../../components/Button';
import { Dropdown } from '../../components/Dropdown';
import { Loading } from '../../components/Loading';

import './MyPortfolio.scss';

export function MyPortfolio() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);
  const SparklineTheme = document.body.classList.contains('dark') ? '000000' : 'fffaed';
  const { isMobile, address, wallets, config, favorites, setFavorites, whales, setWhales } =
    useGlobalContext();
  const { address: account } = useAccount();

  const [showTable, setShowTable] = useState<JSX.Element>(<></>);
  const [tableData, setTableData] = useState<TableDataProps[]>([]);
  const [currentResultData, setCurrentResultData] = useState<TableDataProps[]>([]);

  const [loading, setLoading] = useState(false);
  const [tableWalletFilter, setTableWalletFilter] = useState<string>();
  const [networkFilter, setNetworkFilter] = useState<string[]>([
    'erc20',
    'bep20',
    'polygon',
    'avalanche',
    'moonbeam',
    'moonriver',
  ]);

  const [showRedirect, setShowRedirect] = useState<boolean>(false);

  const [reminderCoingeckoId, setReminderCoingeckoId] = useState<string>();

  const [showAddNewReminder, setShowAddNewReminder] = useState<boolean>(false);

  const getAddressValue = (arr: any, address: string) => {
    return arr.filter((el: any) => {
      return el.address === address ? el : null;
    })[0];
  };

  const openGraphLink = async (address: string): Promise<void> => {
    try {
      setShowRedirect(true);
      setLoading(true);
      const response = await axios({
        url: `${process.env.REACT_APP_API}/fetch-graph-link.php?address=${address}`,
        withCredentials: true,
      });
      setLoading(false);
      console.log(response.data);
      if (response && response.data) {
        const result = JSON.parse(response.data.data);
        console.log(result);
        if (result && result.results) {
          setShowRedirect(false);
          if (isMobile) {
            window.location.assign(
              `https://www.dextools.io/app/en/ether/pair-explorer/${result.results[0].id.pair}`,
            );
          } else {
            window.open(
              `https://www.dextools.io/app/en/ether/pair-explorer/${result.results[0].id.pair}`,
              '_blank',
            );
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  // render graphs
  useEffect(() => {
    if (config && config.globalNetworks) {
      // set table data
      const tmpData: TableDataProps[] = new Array();
      Object.keys(config.globalNetworks).forEach((key: string) => {
        Object.values(config.globalNetworks[key].tokens).forEach((item: any) => {
          if (item.coingeckoid)
            tmpData.push({
              coingeckoid: item.coingeckoid,
              network: config.globalNetworks[key].name,
              logo: config.globalNetworks[key].icon,
              token: item.name,
              symbol: item.symbol,
              category: item.category,
              address: item.address,
              tokenLogo: item.logoURI,
              ratio: `${parseFloat(parseFloat(item.ratio).toFixed(2).toString())}%`,
              ratioRaw: item.ratio,
              holders: item.holders,
              otherNetworkData: wallets
                .map((it: any) => {
                  if (
                    config.networks[it.name] &&
                    config.networks[it.name][key] &&
                    config.networks[it.name][key].tokens &&
                    config.networks[it.name][key].tokens.length > 0
                  ) {
                    const tmp = getAddressValue(config.networks[it.name][key].tokens, item.address);
                    if (tmp) {
                      tmp.wallet = it.name;
                      return tmp;
                    }
                  }
                })
                .flatMap((f: any) => (!!f ? [f] : [])),
              amount: parseAmount(item.amount),
              amountRaw: item.amount,
              balance: parseMoney(item.balance),
              balanceRaw: item.balance,
              pnl24: `${parseMoney(item.pnl.amount)}(${parsePercentage(item.pnl.ratio)})`,
              pnl24amount: parseMoney(item.pnl.amount),
              pnl24percentage: parsePercentage(item.pnl.ratio),
              sparkline:
                config.portfolio[item.coingeckoid] && config.portfolio[item.coingeckoid].graphdata
                  ? config.portfolio[item.coingeckoid].graphdata
                  : '',
              high24h: item.high24h,
              low24h: item.low24h,
              price: parseMoney(item.price),
              ath: item.ath,
              atl: item.atl,
              marketcap: parseAmount(item.marketcap),
              networkKey: key,
              wallets: wallets
                .map((it: any) => {
                  if (
                    config.networks[it.name] &&
                    config.networks[it.name][key] &&
                    config.networks[it.name][key].tokens &&
                    config.networks[it.name][key].tokens.length > 0
                  ) {
                    const tmp = getAddressValue(config.networks[it.name][key].tokens, item.address);
                    if (tmp) {
                      return it.name;
                    }
                  }
                })
                .flatMap((f: any) => (!!f ? [f] : [])),
              color:
                item.graphLastDirection === 'up'
                  ? '90ff00'
                  : item.graphLastDirection === 'down'
                  ? 'ff0000'
                  : 'cccccc',
            });
        });
      });

      setTableData(tmpData);
      setNetworkFilter(
        Object.keys(config.globalNetworks).filter((item: any) => {
          if (Object.values(config.globalNetworks[item].tokens).length) {
            return item;
          }
        }),
      );
    } else {
      renderShowTable({});
      //if (render) setLoading(true);
    }
  }, [config]);

  const renderShowTable = (data: any): void => {
    setShowTable(
      <DataTable
        noDataComponent={
          <div className="data-table-no-record">
            There are no records to display
            <hr />
            <div>
              <small>Maybe you should buy some tokens.</small>
            </div>
          </div>
        }
        pagination
        columns={columns}
        data={data}
        paginationPerPage={7}
        paginationRowsPerPageOptions={[7, 15]}
      />,
    );
  };

  const columns = [
    {
      name: '',
      selector: (row: TableDataProps) => row.network,
      sortable: true,
      cell: (row: TableDataProps) => <CustomNetwork name={''} logo={row.logo} />,
      width: calculateColumnWidth('myPortfolio', 'icon'),
    },
    {
      name: 'Token',
      selector: (row: TableDataProps) => row.token,
      sortable: true,
      cell: (row: TableDataProps) => <CustomToken data={row} />,
      width: calculateColumnWidth('myPortfolio', 'token'),
    },
    {
      name: 'Category',
      selector: (row: TableDataProps) => row.category,
      sortable: true,
      width: calculateColumnWidth('myPortfolio', 'category'),
    },
    {
      name: <img src="/icons/ratio.svg" className="head-image" />,
      selector: (row: TableDataProps) => row.ratioRaw,
      sortable: true,
      width: calculateColumnWidth('myPortfolio', 'ratio'),
      cell: (row: TableDataProps) => row.ratio,
    },
    {
      name: 'Amount',
      selector: (row: TableDataProps) => row.amountRaw,
      sortable: true,
      cell: (row: TableDataProps) => row.amount,
      width: calculateColumnWidth('myPortfolio', 'amount'),
    },
    {
      name: 'Balance ($)',
      selector: (row: TableDataProps) => row.balanceRaw,
      sortable: true,
      cell: (row: TableDataProps) => row.balance,
      width: calculateColumnWidth('myPortfolio', 'balance'),
    },
    {
      name: 'Price',
      selector: (row: TableDataProps) => row.price,
      sortable: true,
      width: calculateColumnWidth('myPortfolio', 'price'),
      cell: (row: TableDataProps) => (
        <>
          <div className={`table-pnl-24`}>
            {row.price}
            <div
              className={`table-pnl-24 ${
                parseFloat(row.pnl24percentage) > 0
                  ? 'green'
                  : parseFloat(row.pnl24percentage) == 0
                  ? ''
                  : 'red'
              }`}
            >
              <span>{row.pnl24amount}</span>
            </div>
          </div>
        </>
      ),
    },
    {
      name: (
        <div className="pnl-head">
          <img src="/icons/graph.svg" className="head-image" /> 24H
        </div>
      ),
      selector: (row: TableDataProps) => row.pnl24,
      width: calculateColumnWidth('myPortfolio', '24h'),
      cell: (row: TableDataProps) => (
        <div
          className={`table-pnl-24 ${
            parseFloat(row.pnl24percentage) > 0
              ? 'green'
              : parseFloat(row.pnl24percentage) == 0
              ? ''
              : 'red'
          }`}
        >
          <strong>{row.pnl24percentage}</strong>
        </div>
      ),
    },
    {
      name: <img src="/icons/diamond.svg" className="head-image" />,
      selector: (row: TableDataProps) => row.holders,
      width: calculateColumnWidth('myPortfolio', 'holders'),
    },
    {
      name: 'Marketcap',
      selector: (row: TableDataProps) => row.marketcap,
      sortable: true,
      width: calculateColumnWidth('myPortfolio', 'marketcap'),
    },
    {
      name: 'Trend Graph',
      selector: (row: TableDataProps) => row.sparkline,
      sortable: false,
      width: calculateColumnWidth('myPortfolio', 'graph'),
      cell: (row: TableDataProps) => (
        <CustomSparkline
          sparkline={row.sparkline}
          color={
            parseFloat(row.pnl24percentage) > 0
              ? 'd5fe88'
              : parseFloat(row.pnl24percentage) == 0
              ? 'ffffff'
              : 'e32a73'
          }
        />
      ),
    },
    {
      name: '+',
      width: calculateColumnWidth('myPortfolio', 'action'),
      cell: (row: TableDataProps) => {
        return (
          <div className={`table-actions`}>
            <Tooltip
              placement="left"
              className="tooltip"
              border="#ff6aff"
              background="var(--color-background-main)"
              color="var(--color-text-main)"
              content={`${
                favorites.tokens && favorites.tokens[row.coingeckoid] ? 'Remove from' : 'Add to'
              } Favorites`}
            >
              <img
                onClick={() => {
                  if (!account) {
                    notify('You need to connect your wallet to use this feature.');
                  } else {
                    if (favorites.tokens[row.coingeckoid]) {
                      remove_favorite_token(favorites.tokens[row.coingeckoid], setFavorites);
                    } else {
                      add_favorite_token(row.coingeckoid, setFavorites);
                    }
                  }
                }}
                className={`${
                  favorites.tokens && favorites.tokens[row.coingeckoid] ? 'active' : ''
                }`}
                style={{ opacity: account ? 1 : 0.6 }}
                src="/icons/star2.svg"
                alt=""
              />
            </Tooltip>
            <Tooltip
              placement="left"
              className="tooltip"
              border="#ff6aff"
              content="Add to Whales"
              background="var(--color-background-main)"
              color="var(--color-text-main)"
            >
              <img
                onClick={() => {
                  if (!account) {
                    notify('You need to connect your wallet to use this feature.');
                  } else {
                    if (whales[row.coingeckoid]) {
                      remove_favorite_whale(whales[row.coingeckoid], setWhales);
                    } else {
                      add_favorite_whale(row.coingeckoid, setWhales);
                    }
                  }
                }}
                style={{ opacity: account ? 1 : 0.6 }}
                className={`${whales && whales[row.coingeckoid] ? 'active' : ''}`}
                src="/icons/whale-2.svg"
                alt=""
              />
            </Tooltip>
            <Tooltip
              placement="left"
              className="tooltip"
              border="#ff6aff"
              content="Set a Reminder"
              background="var(--color-background-main)"
              color="var(--color-text-main)"
            >
              <img
                onClick={(): any => {
                  if (!account) {
                    notify('You need to connect your wallet to use this feature.');
                  } else {
                    setReminderCoingeckoId(row.coingeckoid);
                    setShowAddNewReminder(!showAddNewReminder);
                  }
                }}
                style={{ opacity: account ? 1 : 0.6 }}
                src="/icons/reminder.svg"
                alt=""
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const onClose = (): void => {
    setShowAddNewReminder(false);
  };

  interface TableDataProps {
    coingeckoid: string;
    network: string;
    logo: string;
    token: string;
    symbol: string;
    tokenLogo: string;
    address: string;
    amount: string;
    balance: string;
    balanceRaw: number;
    amountRaw: number;
    pnl24: string;
    pnl24amount: string;
    pnl24percentage: string;
    ratio: string;
    ratioRaw: number;
    sparkline: string;
    color: string;
    holders: 0;
    high24h: string;
    low24h: string;
    price: string;
    ath: string;
    atl: string;
    marketcap: string;
    category: string;
    networkKey: string;
    otherNetworkData: any;
    wallet?: string;
    wallets?: any;
  }

  interface CustomTokenProps {
    data: TableDataProps;
  }

  const CustomToken = (props: CustomTokenProps) => {
    return (
      <>
        <div className="icon-container-dark">
          <img
            src={props.data.tokenLogo}
            className={`tokenLogo ${props.data.tokenLogo.includes('/networks/') ? 'native' : ''}`}
          />
        </div>
        {wallets.length > 1 ? (
          <Tooltip
            placement="right"
            className="tooltip"
            border="#ff6aff"
            background="var(--color-background-main)"
            color="var(--color-text-main)"
            content={props.data.otherNetworkData.map((item: any, index: number) => {
              return (
                <div className="wallet-item" key={index}>
                  <div>{item.wallet} </div>
                  <div>
                    {item.amount} {item.symbol}
                  </div>
                </div>
              );
            })}
          >
            <div
              className="token-name-container"
              title={props.data.token && props.data.token.length > 12 ? props.data.token : ''}
            >
              {props.data.token}
            </div>
          </Tooltip>
        ) : (
          <div
            className="token-name-container"
            title={props.data.token && props.data.token.length > 12 ? props.data.token : ''}
          >
            {props.data.token}
          </div>
        )}
        <div className="chart-icon" onClick={() => openGraphLink(props.data.address)}>
          <img src={`/icons/chart-${theme}.svg`} alt="" />
        </div>
        {((config.moonbeamLP &&
          config.moonbeamLP.some(
            (checkItem: any) =>
              checkItem.token0.id.toLowerCase() === props.data.address.toLowerCase() ||
              checkItem.token1.id.toLowerCase() === props.data.address.toLowerCase(),
          )) ||
          (config.moonriverLP &&
            config.moonriverLP.some(
              (checkItem: any) =>
                checkItem.token0.id.toLowerCase() === props.data.address.toLowerCase() ||
                checkItem.token1.id.toLowerCase() === props.data.address.toLowerCase(),
            ))) && (
          <div className="lp-icon">
            <Link
              className="insite-link"
              to={{ pathname: '/statistics-fees', state: { selectedType: 'lp' } }}
            >
              <Tooltip
                placement="right"
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content={
                  <>
                    There are available liquidity pools for your portfolio. Click here to see more.
                  </>
                }
              >
                <span></span>
              </Tooltip>
            </Link>
          </div>
        )}
      </>
    );
  };

  interface CustomNetworkProps {
    name: string;
    logo: string;
    ads?: boolean;
  }

  const CustomNetwork = (props: CustomNetworkProps) => {
    return (
      <>
        <div className={`icon-container-${theme}`}>
          <img src={props.logo} className={props.logo.includes('/networks/') ? 'native' : ''} />
        </div>
        {props.name}
        {props.ads && (
          <div
            className="adsBuyTableLink"
            onClick={(e: any) => e.target.classList.toggle('active')}
          >
            Buy
            <div className="details">
              <div
                className="close"
                onClick={(e: any) => e.target.parentNode.parentNode.classList.toggle('active')}
              >
                &times;
              </div>
              <div className="sponsored">
                <div className="sponsored-warning">
                  <img src="/images/icon-dark.svg" />
                  Sponsored
                </div>
                <div className="binance">
                  <div className="header-part">
                    <img src="/sponsored/binance/binance.png" /> Binance
                  </div>
                  <div className="description-part">
                    Buy Crypto with Fees as Low as 0%
                    <Link target="_blank" to={{ pathname: 'https://www.binance.com' }}>
                      Start Trading
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  interface CustomSparklineProps {
    sparkline: string;
    color: string;
  }

  // 5cb85c
  const CustomSparkline = (props: CustomSparklineProps) => {
    const arrOfStr = props.sparkline ? props.sparkline.split(',') : [0];
    const arrOfNum: number[] = [];
    arrOfStr.forEach(str => {
      arrOfNum.push(Number(str));
    });
    const min = Math.min(...arrOfNum);
    const max = Math.max(...arrOfNum);
    return (
      <>
        <div className="sparkline-container" style={{ width: '100px' }}>
          <img
            src={`https://chart.googleapis.com/chart?chco=${props.color}&chf=bg,s,${SparklineTheme}&cht=lc:nda&chds=${min},${max}&chs=100x34&chd=t:${props.sparkline}`}
          />
        </div>
      </>
    );
  };

  const setDataFilter = (networks?: string[], wallet?: string) => {
    let filteredData: any[] = [];
    if (networks && tableData) {
      filteredData = tableData.filter(item => {
        return networks ? networks.includes(item.networkKey) : true;
      });
    }
    if (wallet && filteredData) {
      filteredData = filteredData.filter(item => {
        return wallet ? item.wallets.includes(wallet) : true;
      });
    }

    renderShowTable(filteredData);
  };

  useEffect(() => {
    setDataFilter(networkFilter, tableWalletFilter);
  }, [networkFilter, tableWalletFilter, favorites, whales]);

  useEffect(() => {
    renderShowTable(tableData);

    if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [tableData]);

  const portfolioWalletChange = (value: string) => {
    setTableWalletFilter(value);
  };

  const csvHeader = [
    'Wallet Name',
    'Wallet Address',
    'Network',
    'Token',
    'Symbol',
    'Ratio',
    'Amount',
    'Balance ($)',
    'Price',
    '24H',
    'Marketcap',
  ];

  useEffect(() => {
    const resultData: any[] = [];
    const exportResultData: any[] = [];
    Object.keys(config.networks).forEach((walletName: string) => {
      Object.keys(config.networks[walletName]).forEach((networkName: string) => {
        config.networks[walletName][networkName].tokens.forEach((token: any) => {
          exportResultData.push({
            Wallet: walletName,
            WalletAddress: wallets.filter(item => item.name === walletName)[0].address,
            Network: networkName,
            Token: token.name,
            Symbol: token.symbol,
            Ratio: token.ratio,
            Amount: token.amount.toString(),
            Balance: token.balance.toString(),
            Price: token.price.toString(),
            PNL: token.pnl.ratio.toString(),
            Marketcap: token.marketcap.toString(),
          });
          resultData.push([
            walletName,
            wallets.filter(item => item.name === walletName)[0].address,
            networkName,
            token.name,
            token.symbol,
            token.ratio,
            token.amount.toString(),
            token.balance.toString(),
            token.price.toString(),
            token.pnl.ratio.toString(),
            token.marketcap.toString(),
          ]);
        });
      });
    });

    let exportFilteredData: any[] = [];
    if (networkFilter) {
      exportFilteredData = exportResultData.filter(item => {
        return networkFilter ? networkFilter.includes(item['Network']) : true;
      });
    }
    if (tableWalletFilter) {
      exportFilteredData = exportResultData.filter(item => {
        return tableWalletFilter ? item['Wallet'] === tableWalletFilter : true;
      });
    }

    setCurrentResultData(exportResultData ? exportResultData : exportFilteredData);
  }, [networkFilter, tableWalletFilter, networkFilter, tableWalletFilter]);

  return (
    <div className="my-portfolio">
      <BigMenu horizontal={true} />
      {loading && !address && (
        <>
          <Loading inline={true} />
          <div className="grayedOut" />
        </>
      )}
      {config && (
        <>
          <div className={`network-selectors-${theme}`} id="network-selectors">
            <div
              className="allFilter active"
              id="allFilterItem"
              style={{ marginBottom: '5px' }}
              onClick={(): void => {
                const items: any = document.getElementById('network-selectors');

                for (let i = 0; i < items.children.length; i++) {
                  items.children[i].classList.remove('active');
                }

                document.getElementById('allFilterItem')!.classList.add('active');
                setDataFilter(['erc20', 'bep20', 'polygon', 'avalanche', 'moonbeam', 'moonriver']);
                setNetworkFilter(
                  Object.keys(config.globalNetworks).filter((item: any) => {
                    if (Object.values(config.globalNetworks[item].tokens).length) {
                      return item;
                    }
                  }),
                );
              }}
            >
              <img className="activeImage" src="icons/networks/all.png" alt="" />
              <img className="normal" src="icons/networks/all.png" alt="" />
            </div>
            {config.globalNetworks &&
              Object.keys(config.globalNetworks).map((index: any) => {
                return (
                  <div
                    key={`${index}`}
                    data-id={index}
                    className={`${config.globalNetworks[index].balance === 0 ? 'disabled' : ''}`}
                  >
                    <img
                      className="activeImage"
                      onClick={(e: any): void => {
                        const items: any = document.getElementById('network-selectors');
                        const newValues: string[] = [];

                        for (let i = 0; i < items.children.length; i++) {
                          items.children[i].classList.remove('active');
                        }
                        newValues.push(e.target.parentNode.getAttribute('data-id'));
                        e.target.parentNode.classList.add('active');
                        setNetworkFilter(newValues);
                      }}
                      src={config.globalNetworks[index].icon}
                    />

                    <img
                      className="normal"
                      onClick={(e: any): void => {
                        const items: any = document.getElementById('network-selectors');
                        const newValues: string[] = [];

                        for (let i = 0; i < items.children.length; i++) {
                          items.children[i].classList.remove('active');
                        }
                        newValues.push(e.target.parentNode.getAttribute('data-id'));
                        e.target.parentNode.classList.add('active');
                        setNetworkFilter(newValues);
                      }}
                      src={config.globalNetworks[index].icon}
                    />
                  </div>
                );
              })}
          </div>
          {isMobile && wallets && wallets.length > 1 && (
            <div className="table-wallet-filter" style={{ height: '40px', top: '0' }}>
              <Dropdown
                change={(value: string) => portfolioWalletChange(value)}
                color="white"
                size="small"
                label="All Wallets"
              >
                <div key={`table-wallet-all`}>All Wallets</div>
                {wallets &&
                  wallets.map((item: any, index: number) => {
                    return (
                      <div key={`table-wallet-${index}`} data-id={item.name}>
                        {item.name}
                      </div>
                    );
                  })}
              </Dropdown>
            </div>
          )}
          <div className={isMobile ? 'mobile-portfolio-dashboard' : 'portfolio-dashboard'}>
            {!isMobile && (
              <div className="item">
                <Tooltip
                  placement="right"
                  className="tooltip dashboard-tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content={
                    <div className="wallet-item">
                      <div>{tableWalletFilter || 'All Wallets'} </div>
                      <div>
                        {networkFilter &&
                          networkFilter.map((i: any, ind: number) => {
                            return <img key={ind} src={`/icons/networks/${i}.png`} alt="" />;
                          })}
                      </div>
                    </div>
                  }
                >
                  <div className="question-circle">?</div>
                </Tooltip>
              </div>
            )}
            <div className="item">
              # of Tokens{' '}
              <Tooltip
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total unique token count in portfolio."
              >
                <div className="portfolio-value sh-small text-color-three">
                  {wallets && wallets.length > 1 && tableWalletFilter
                    ? parseNumber(
                        Object.values(
                          Object.keys(config.networks[tableWalletFilter]).map((key: any) => {
                            return networkFilter.includes(key)
                              ? Object.values(config.networks[tableWalletFilter][key].tokens).length
                              : 0;
                          }),
                        ).reduce((a: any, b: any) => a + b, 0),
                      )
                    : parseNumber(
                        Object.values(
                          Object.keys(config.globalNetworks).map((key: any) => {
                            return networkFilter.includes(key)
                              ? Object.values(config.globalNetworks[key].tokens).length
                              : 0;
                          }),
                        ).reduce((a: any, b: any) => a + b, 0),
                      )}
                </div>
              </Tooltip>
            </div>

            <div className="item">
              24H PNL{' '}
              <Tooltip
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total changes of your main portfolio in 24 hours."
              >
                {wallets && wallets.length > 1 && tableWalletFilter ? (
                  parseMoney(
                    Object.values(
                      Object.keys(config.networks[tableWalletFilter]).map((key: any) => {
                        return networkFilter.includes(key)
                          ? parseFloat(config.networks[tableWalletFilter][key].pnlAmount)
                          : 0;
                      }),
                    ).reduce((a: any, b: any) => a + b, 0),
                    false,
                    2,
                  )
                ) : networkFilter.length === 1 ? (
                  <div className="change-amount sh-small text-color-one">
                    {parseMoney(config.globalNetworks[networkFilter[0]].pnlAmount, false, 2)}{' '}
                    <span className="hidden-m">
                      ( {parsePercentage(config.globalNetworks[networkFilter[0]].pnlRatio)})
                    </span>
                  </div>
                ) : (
                  <div className="change-amount sh-small text-color-one">
                    {parseMoney(config.pnl.amount)}{' '}
                    <span className="hidden-m">( {parsePercentage(config.pnl.ratio)})</span>
                  </div>
                )}
              </Tooltip>
            </div>

            <div className="item">
              Total Fee{' '}
              <Tooltip
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total spent fee in current USD currency."
              >
                <div className="portfolio-value sh-small text-color-two">
                  {wallets && wallets.length > 1 && tableWalletFilter
                    ? parseMoney(
                        Object.values(
                          Object.keys(config.networks[tableWalletFilter]).map((key: any) => {
                            return networkFilter.includes(key)
                              ? parseFloat(config.networks[tableWalletFilter][key].fees.total)
                              : 0;
                          }),
                        ).reduce((a: any, b: any) => a + b, 0),
                        false,
                        2,
                      )
                    : networkFilter.length === 1
                    ? parseMoney(config.globalNetworks[networkFilter[0]].fees, false, 2)
                    : parseMoney(config.fees)}
                </div>
              </Tooltip>
            </div>

            <div className="item">
              Total Balance{' '}
              <Tooltip
                className="tooltip"
                border="#ff6aff"
                content="Total portfolio USD value."
                background="var(--color-background-main)"
                color="var(--color-text-main)"
              >
                <div className="portfolio-value sh-small text-color-five">
                  {wallets && wallets.length > 1 && tableWalletFilter
                    ? parseMoney(
                        Object.values(
                          Object.keys(config.networks[tableWalletFilter]).map((key: any) => {
                            return networkFilter.includes(key)
                              ? parseFloat(config.networks[tableWalletFilter][key].balance)
                              : 0;
                          }),
                        ).reduce((a: any, b: any) => a + b, 0),
                        false,
                        2,
                      )
                    : networkFilter.length === 1
                    ? parseMoney(config.globalNetworks[networkFilter[0]].balance, false, 2)
                    : parseMoney(config.balance)}
                </div>
              </Tooltip>
            </div>
          </div>

          {!isMobile && wallets && wallets.length > 1 && (
            <div className="table-wallet-filter">
              <Dropdown
                change={(value: string) => portfolioWalletChange(value)}
                color="white"
                size="small"
                label="All Wallets"
              >
                <div key={`table-wallet-all`}>All Wallets</div>
                {wallets &&
                  wallets.map((item: any, index: number) => {
                    return (
                      <div key={`table-wallet-${index}`} data-id={item.name}>
                        {item.name}
                      </div>
                    );
                  })}
              </Dropdown>

              <div
                style={{
                  display: 'inline-flex',
                  overflow: 'hidden',
                  position: 'relative',
                  justifyContent: 'center',
                  width: '32px',
                }}
              >
                <DownloadExcel
                  data={currentResultData}
                  buttonLabel="E"
                  fileName="WalletScan - Portfolio Export"
                  itemKey="export-xls-button"
                />
                <Button color="black" size="small" icon="xls" />
              </div>

              <CsvDownloadButton
                headers={csvHeader}
                data={currentResultData}
                filename="WalletScan - Portfolio Export.csv"
                style={{
                  //pass other props, like styles
                  border: 'none',
                  background: 'transparent',
                  padding: '0',
                  cursor: 'pointer',
                }}
              >
                <Button color="black" size="small" icon="csv" />
              </CsvDownloadButton>
            </div>
          )}
          <div
            className={`custom-table-${theme} ${
              !(isMobile && wallets && wallets.length > 1) ? 'mt-5' : ''
            }`}
          >
            <div className={`table-border-top-${theme} mt-2`} />
            {showTable}
            <div className={`table-border-bottom-${theme}`} />
          </div>
        </>
      )}
      {showAddNewReminder && reminderCoingeckoId && (
        <AddReminderToken coingeckoid={reminderCoingeckoId} onClose={onClose} />
      )}

      {showRedirect && (
        <>
          <div className="grayedOut" />
          <div className="redirect-to-dextools">
            You are being redirected to Dextools.io in a few seconds.
          </div>
        </>
      )}
    </div>
  );
}
